import { render, staticRenderFns } from "./DeleteCancelConfirmModal.vue?vue&type=template&id=6005b6d8"
import script from "./DeleteCancelConfirmModal.vue?vue&type=script&lang=js"
export * from "./DeleteCancelConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports